
export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg flex items-center justify-center">
                <i className="ri-calculator-line text-white text-xl"></i>
              </div>
              <span className="text-2xl font-bold text-white">CBN ACCOUNTING LIMITED</span>
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              Professional accounting and tax services for UK businesses. Helping you succeed with expert financial solutions.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('home')} className="hover:text-blue-400 transition-colors cursor-pointer text-left">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="hover:text-blue-400 transition-colors cursor-pointer text-left">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('why-us')} className="hover:text-blue-400 transition-colors cursor-pointer text-left">
                  Why Choose Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="hover:text-blue-400 transition-colors cursor-pointer text-left">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-6">Our Services</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="hover{text-blue-400 transition-colors cursor-pointer text-left">
                  Tax Returns & Planning
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="hover{text-blue-400 transition-colors cursor-pointer text-left">
                  Bookkeeping & Accounting
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="hover{text-blue-400 transition-colors cursor-pointer text-left">
                  VAT Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="hover{text-blue-400 transition-colors cursor-pointer text-left">
                  Payroll Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="hover{text-blue-400 transition-colors cursor-pointer text-left">
                  Business Advisory
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-6">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-blue-400 text-xl mt-1"></i>
                <div>
                  <p>44 High Street</p>
                  <p>Chatham, Kent ME4 4DS</p>
                  <p>United Kingdom</p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-blue-400 text-xl"></i>
                <span>07871625763</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-blue-400 text-xl"></i>
                <span>Info@Cbnaccounting.co.uk</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} CBN ACCOUNTING LIMITED. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors text-sm cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors text-sm cursor-pointer">
                Terms of Service
              </a>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors text-sm cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
